var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":_vm.url}},[_c('div',{staticClass:"card"},[_c('img',{attrs:{"src":_vm.imgsrc,"alt":_vm.imgalt}}),_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card__subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }